import FormBody from "../../../../components/form-body";
import Input from "../../../../components/input";
import Label from "../../../../components/label";

export default function ShoppingCompanySkeleton() {
  return (
    <div className="max-w-3xl space-y-6 py-8 text-left">
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Name</Label>
          <Input id="name" name="name" type="text" className="animate-pulse bg-gray-100" disabled />
        </div>
        <div className="mb-4">
          <Label htmlFor="discountCode">Discount code</Label>
          <Input id="discountCode" name="discountCode" type="text" className="animate-pulse bg-gray-100" disabled />
        </div>
        <div className="mb-4">
          <Label htmlFor="url">Url</Label>
          <Input id="url" name="url" type="text" className="animate-pulse bg-gray-100" disabled />
        </div>
      </FormBody>
    </div>
  );
}
